<template>
	<div class="fd-dump">{{ dump }}</div>
</template>

<script>
export default {
	name: "JsonDump",
	props: {
		data: {
			type: [Object, Array],
			required: true,
		},
	},
	computed: {
		dump() {
			return JSON.stringify(this.data);
		},
	},
};
</script>

<style>
.fd-dump {
	font-size: 10px;
	font-family: monospace;
	padding: 4px;
	box-sizing: border-box;
}
</style>
